<template>

  <div>
    <v-list-item link :to="'/home'">
      <v-list-item-icon>
        <v-icon>mdi-home-account</v-icon>
      </v-list-item-icon>
      <v-list-item-title>Home</v-list-item-title>
    </v-list-item>
    <v-list-item link :to="'/find'">
          <v-list-item-icon>
            <v-icon>mdi-account-search</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Find a Lab Member</v-list-item-title>
        </v-list-item>
    <v-subheader>My HR</v-subheader>
        <v-list-item link :to="'/my/actions'">
          <v-list-item-icon>
            <v-icon>mdi-account-question</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Actions Required (3)</v-list-item-title>
        </v-list-item>
        <v-list-item link :to="'/my/requests'">
          <v-list-item-icon>
            <v-icon>mdi-account-plus</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Requests</v-list-item-title>
        </v-list-item>
        <v-list-item link :to="'/my/info'">
          <v-list-item-icon>
            <v-icon>mdi-account</v-icon>
          </v-list-item-icon>
          <v-list-item-title>My Information</v-list-item-title>
        </v-list-item>
        
        <!-- <v-list-item link :to="'/reservations/my'">
          <v-list-item-icon>
            <v-icon>mdi-office-building</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Update Room</v-list-item-title>
        </v-list-item> -->
  </div>
</template>

<script>

export default {
  name: 'MitMenuUser',
  components: {
  },
  props: {
    userModel: Object
  },
  data() {
    return {
    }
  },
  created() {
  }

}
</script>

<style lang="scss" scoped>
</style>
